/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface UpdateUserProfileRequest
 */
export interface UpdateUserProfileRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    password?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    passwordConfirmation?: string;
}

export function UpdateUserProfileRequestFromJSON(json: any): UpdateUserProfileRequest {
    return UpdateUserProfileRequestFromJSONTyped(json, false);
}

export function UpdateUserProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserProfileRequest {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
        lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
        email: !exists(json, 'email') ? undefined : json['email'],
        password: !exists(json, 'password') ? undefined : json['password'],
        passwordConfirmation: !exists(json, 'passwordConfirmation') ? undefined : json['passwordConfirmation'],
    };
}

export function UpdateUserProfileRequestToJSON(value?: UpdateUserProfileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        password: value.password,
        passwordConfirmation: value.passwordConfirmation,
    };
}
